/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseListInboundOutBoundPicVo,
  ResponseListParcelInboundPicVo,
  ResponseOrderFileVo,
  ResponseString,
} from '../models/index';
import {
    ResponseListInboundOutBoundPicVoFromJSON,
    ResponseListInboundOutBoundPicVoToJSON,
    ResponseListParcelInboundPicVoFromJSON,
    ResponseListParcelInboundPicVoToJSON,
    ResponseOrderFileVoFromJSON,
    ResponseOrderFileVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface OrderFileComfirmNodataImageNoDataIdPostRequest {
    noDataId: number;
    sendSms?: number;
}

export interface OrderFileComfirmOrderImageOrderIdPostRequest {
    orderId: number;
    sendSms?: number;
}

export interface OrderFileComfirmParcelImageParcelIdPostRequest {
    parcelId: number;
    sendSms?: number;
}

export interface OrderFileConfirmOutboundImgPostRequest {
    orderId: number;
}

export interface OrderFileDeleteFileDeleteRequest {
    fileId: number;
}

export interface OrderFileGetInboundImageByGoodsGetRequest {
    goodsId: number;
}

export interface OrderFileGetInboundParcelImageByOrderIdGetRequest {
    orderId: number;
}

export interface OrderFileGetNodataImagesGetRequest {
    nodataId: number;
}

export interface OrderFileGetOutboundImageByOrderGetRequest {
    orderId: number;
}

export interface OrderFileGetParcelInboundPicGetRequest {
    trackingNo: string;
}

export interface OrderFileUploadBatchNoDataImgPostRequest {
    usageType: string;
    noDataId: number;
    files: Blob;
    staffId?: number;
}

export interface OrderFileUploadBatchOrderImgPostRequest {
    usageType: string;
    orderId: number;
    files: Blob;
    staffId?: number;
}

export interface OrderFileUploadBatchOutboundImgPostRequest {
    usageType: string;
    orderId: number;
    files: Blob;
    staffId?: number;
}

export interface OrderFileUploadBatchParcelImgPostRequest {
    usageType: string;
    parcelId: number;
    files: Blob;
    staffId?: number;
}

export interface OrderFileUploadCoupangFilePostRequest {
    usageType: string;
    orderId: number;
    fileType: number;
    file: Blob;
}

export interface OrderFileUploadOutboundImgPostRequest {
    usageType: string;
    orderId: number;
    file: Blob;
    staffId?: number;
}

/**
 * 
 */
export class OrderFileControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 无数据入库照片确认
     */
    async orderFileComfirmNodataImageNoDataIdPostRaw(requestParameters: OrderFileComfirmNodataImageNoDataIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['noDataId'] == null) {
            throw new runtime.RequiredError(
                'noDataId',
                'Required parameter "noDataId" was null or undefined when calling orderFileComfirmNodataImageNoDataIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sendSms'] != null) {
            queryParameters['sendSms'] = requestParameters['sendSms'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/comfirmNodataImage/{noDataId}`.replace(`{${"noDataId"}}`, encodeURIComponent(String(requestParameters['noDataId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 无数据入库照片确认
     */
    async orderFileComfirmNodataImageNoDataIdPost(requestParameters: OrderFileComfirmNodataImageNoDataIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileComfirmNodataImageNoDataIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 订单入库照片确认
     */
    async orderFileComfirmOrderImageOrderIdPostRaw(requestParameters: OrderFileComfirmOrderImageOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderFileComfirmOrderImageOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sendSms'] != null) {
            queryParameters['sendSms'] = requestParameters['sendSms'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/comfirmOrderImage/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 订单入库照片确认
     */
    async orderFileComfirmOrderImageOrderIdPost(requestParameters: OrderFileComfirmOrderImageOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileComfirmOrderImageOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 快递入库照片确认
     */
    async orderFileComfirmParcelImageParcelIdPostRaw(requestParameters: OrderFileComfirmParcelImageParcelIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['parcelId'] == null) {
            throw new runtime.RequiredError(
                'parcelId',
                'Required parameter "parcelId" was null or undefined when calling orderFileComfirmParcelImageParcelIdPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sendSms'] != null) {
            queryParameters['sendSms'] = requestParameters['sendSms'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/comfirmParcelImage/{parcelId}`.replace(`{${"parcelId"}}`, encodeURIComponent(String(requestParameters['parcelId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 快递入库照片确认
     */
    async orderFileComfirmParcelImageParcelIdPost(requestParameters: OrderFileComfirmParcelImageParcelIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileComfirmParcelImageParcelIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 确认出库照片
     */
    async orderFileConfirmOutboundImgPostRaw(requestParameters: OrderFileConfirmOutboundImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderFileConfirmOutboundImgPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/confirmOutboundImg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 确认出库照片
     */
    async orderFileConfirmOutboundImgPost(requestParameters: OrderFileConfirmOutboundImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileConfirmOutboundImgPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除文件
     */
    async orderFileDeleteFileDeleteRaw(requestParameters: OrderFileDeleteFileDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['fileId'] == null) {
            throw new runtime.RequiredError(
                'fileId',
                'Required parameter "fileId" was null or undefined when calling orderFileDeleteFileDelete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fileId'] != null) {
            queryParameters['fileId'] = requestParameters['fileId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/deleteFile`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除文件
     */
    async orderFileDeleteFileDelete(requestParameters: OrderFileDeleteFileDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileDeleteFileDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取入库图片 商品级别获取 商品级的可以是货车入库号的入库也可以是快递的入库
     */
    async orderFileGetInboundImageByGoodsGetRaw(requestParameters: OrderFileGetInboundImageByGoodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListInboundOutBoundPicVo>> {
        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling orderFileGetInboundImageByGoodsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['goodsId'] != null) {
            queryParameters['goodsId'] = requestParameters['goodsId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/getInboundImageByGoods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListInboundOutBoundPicVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取入库图片 商品级别获取 商品级的可以是货车入库号的入库也可以是快递的入库
     */
    async orderFileGetInboundImageByGoodsGet(requestParameters: OrderFileGetInboundImageByGoodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListInboundOutBoundPicVo> {
        const response = await this.orderFileGetInboundImageByGoodsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取入库图片 订单级别获取
     */
    async orderFileGetInboundParcelImageByOrderIdGetRaw(requestParameters: OrderFileGetInboundParcelImageByOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListInboundOutBoundPicVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderFileGetInboundParcelImageByOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/getInboundParcelImageByOrderId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListInboundOutBoundPicVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取入库图片 订单级别获取
     */
    async orderFileGetInboundParcelImageByOrderIdGet(requestParameters: OrderFileGetInboundParcelImageByOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListInboundOutBoundPicVo> {
        const response = await this.orderFileGetInboundParcelImageByOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取无数据图片
     */
    async orderFileGetNodataImagesGetRaw(requestParameters: OrderFileGetNodataImagesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListInboundOutBoundPicVo>> {
        if (requestParameters['nodataId'] == null) {
            throw new runtime.RequiredError(
                'nodataId',
                'Required parameter "nodataId" was null or undefined when calling orderFileGetNodataImagesGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nodataId'] != null) {
            queryParameters['nodataId'] = requestParameters['nodataId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/getNodataImages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListInboundOutBoundPicVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取无数据图片
     */
    async orderFileGetNodataImagesGet(requestParameters: OrderFileGetNodataImagesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListInboundOutBoundPicVo> {
        const response = await this.orderFileGetNodataImagesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取出库图片 订单级别
     */
    async orderFileGetOutboundImageByOrderGetRaw(requestParameters: OrderFileGetOutboundImageByOrderGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListInboundOutBoundPicVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderFileGetOutboundImageByOrderGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/getOutboundImageByOrder`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListInboundOutBoundPicVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取出库图片 订单级别
     */
    async orderFileGetOutboundImageByOrderGet(requestParameters: OrderFileGetOutboundImageByOrderGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListInboundOutBoundPicVo> {
        const response = await this.orderFileGetOutboundImageByOrderGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 用快递运单号查询入库照片
     */
    async orderFileGetParcelInboundPicGetRaw(requestParameters: OrderFileGetParcelInboundPicGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListParcelInboundPicVo>> {
        if (requestParameters['trackingNo'] == null) {
            throw new runtime.RequiredError(
                'trackingNo',
                'Required parameter "trackingNo" was null or undefined when calling orderFileGetParcelInboundPicGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['trackingNo'] != null) {
            queryParameters['trackingNo'] = requestParameters['trackingNo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/orderFile/getParcelInboundPic`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListParcelInboundPicVoFromJSON(jsonValue));
    }

    /**
     * 
     * 用快递运单号查询入库照片
     */
    async orderFileGetParcelInboundPicGet(requestParameters: OrderFileGetParcelInboundPicGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListParcelInboundPicVo> {
        const response = await this.orderFileGetParcelInboundPicGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 无数据批量上传文件
     */
    async orderFileUploadBatchNoDataImgPostRaw(requestParameters: OrderFileUploadBatchNoDataImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['usageType'] == null) {
            throw new runtime.RequiredError(
                'usageType',
                'Required parameter "usageType" was null or undefined when calling orderFileUploadBatchNoDataImgPost().'
            );
        }

        if (requestParameters['noDataId'] == null) {
            throw new runtime.RequiredError(
                'noDataId',
                'Required parameter "noDataId" was null or undefined when calling orderFileUploadBatchNoDataImgPost().'
            );
        }

        if (requestParameters['files'] == null) {
            throw new runtime.RequiredError(
                'files',
                'Required parameter "files" was null or undefined when calling orderFileUploadBatchNoDataImgPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['usageType'] != null) {
            queryParameters['usageType'] = requestParameters['usageType'];
        }

        if (requestParameters['noDataId'] != null) {
            queryParameters['noDataId'] = requestParameters['noDataId'];
        }

        if (requestParameters['staffId'] != null) {
            queryParameters['staffId'] = requestParameters['staffId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['files'] != null) {
            formParams.append('files', requestParameters['files'] as any);
        }

        const response = await this.request({
            path: `/orderFile/uploadBatchNoDataImg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 无数据批量上传文件
     */
    async orderFileUploadBatchNoDataImgPost(requestParameters: OrderFileUploadBatchNoDataImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileUploadBatchNoDataImgPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 订单批量上传文件
     */
    async orderFileUploadBatchOrderImgPostRaw(requestParameters: OrderFileUploadBatchOrderImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['usageType'] == null) {
            throw new runtime.RequiredError(
                'usageType',
                'Required parameter "usageType" was null or undefined when calling orderFileUploadBatchOrderImgPost().'
            );
        }

        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderFileUploadBatchOrderImgPost().'
            );
        }

        if (requestParameters['files'] == null) {
            throw new runtime.RequiredError(
                'files',
                'Required parameter "files" was null or undefined when calling orderFileUploadBatchOrderImgPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['usageType'] != null) {
            queryParameters['usageType'] = requestParameters['usageType'];
        }

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        if (requestParameters['staffId'] != null) {
            queryParameters['staffId'] = requestParameters['staffId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['files'] != null) {
            formParams.append('files', requestParameters['files'] as any);
        }

        const response = await this.request({
            path: `/orderFile/uploadBatchOrderImg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 订单批量上传文件
     */
    async orderFileUploadBatchOrderImgPost(requestParameters: OrderFileUploadBatchOrderImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileUploadBatchOrderImgPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量上传出库实拍图片
     */
    async orderFileUploadBatchOutboundImgPostRaw(requestParameters: OrderFileUploadBatchOutboundImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['usageType'] == null) {
            throw new runtime.RequiredError(
                'usageType',
                'Required parameter "usageType" was null or undefined when calling orderFileUploadBatchOutboundImgPost().'
            );
        }

        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderFileUploadBatchOutboundImgPost().'
            );
        }

        if (requestParameters['files'] == null) {
            throw new runtime.RequiredError(
                'files',
                'Required parameter "files" was null or undefined when calling orderFileUploadBatchOutboundImgPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['usageType'] != null) {
            queryParameters['usageType'] = requestParameters['usageType'];
        }

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        if (requestParameters['staffId'] != null) {
            queryParameters['staffId'] = requestParameters['staffId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['files'] != null) {
            formParams.append('files', requestParameters['files'] as any);
        }

        const response = await this.request({
            path: `/orderFile/uploadBatchOutboundImg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 批量上传出库实拍图片
     */
    async orderFileUploadBatchOutboundImgPost(requestParameters: OrderFileUploadBatchOutboundImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileUploadBatchOutboundImgPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 快递批量上传文件
     */
    async orderFileUploadBatchParcelImgPostRaw(requestParameters: OrderFileUploadBatchParcelImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['usageType'] == null) {
            throw new runtime.RequiredError(
                'usageType',
                'Required parameter "usageType" was null or undefined when calling orderFileUploadBatchParcelImgPost().'
            );
        }

        if (requestParameters['parcelId'] == null) {
            throw new runtime.RequiredError(
                'parcelId',
                'Required parameter "parcelId" was null or undefined when calling orderFileUploadBatchParcelImgPost().'
            );
        }

        if (requestParameters['files'] == null) {
            throw new runtime.RequiredError(
                'files',
                'Required parameter "files" was null or undefined when calling orderFileUploadBatchParcelImgPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['usageType'] != null) {
            queryParameters['usageType'] = requestParameters['usageType'];
        }

        if (requestParameters['parcelId'] != null) {
            queryParameters['parcelId'] = requestParameters['parcelId'];
        }

        if (requestParameters['staffId'] != null) {
            queryParameters['staffId'] = requestParameters['staffId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['files'] != null) {
            formParams.append('files', requestParameters['files'] as any);
        }

        const response = await this.request({
            path: `/orderFile/uploadBatchParcelImg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 快递批量上传文件
     */
    async orderFileUploadBatchParcelImgPost(requestParameters: OrderFileUploadBatchParcelImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileUploadBatchParcelImgPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传coupang文件
     */
    async orderFileUploadCoupangFilePostRaw(requestParameters: OrderFileUploadCoupangFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderFileVo>> {
        if (requestParameters['usageType'] == null) {
            throw new runtime.RequiredError(
                'usageType',
                'Required parameter "usageType" was null or undefined when calling orderFileUploadCoupangFilePost().'
            );
        }

        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderFileUploadCoupangFilePost().'
            );
        }

        if (requestParameters['fileType'] == null) {
            throw new runtime.RequiredError(
                'fileType',
                'Required parameter "fileType" was null or undefined when calling orderFileUploadCoupangFilePost().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling orderFileUploadCoupangFilePost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['usageType'] != null) {
            queryParameters['usageType'] = requestParameters['usageType'];
        }

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        if (requestParameters['fileType'] != null) {
            queryParameters['fileType'] = requestParameters['fileType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/orderFile/uploadCoupangFile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderFileVoFromJSON(jsonValue));
    }

    /**
     * 
     * 上传coupang文件
     */
    async orderFileUploadCoupangFilePost(requestParameters: OrderFileUploadCoupangFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderFileVo> {
        const response = await this.orderFileUploadCoupangFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传出库实拍图片
     */
    async orderFileUploadOutboundImgPostRaw(requestParameters: OrderFileUploadOutboundImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['usageType'] == null) {
            throw new runtime.RequiredError(
                'usageType',
                'Required parameter "usageType" was null or undefined when calling orderFileUploadOutboundImgPost().'
            );
        }

        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderFileUploadOutboundImgPost().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling orderFileUploadOutboundImgPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['usageType'] != null) {
            queryParameters['usageType'] = requestParameters['usageType'];
        }

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        if (requestParameters['staffId'] != null) {
            queryParameters['staffId'] = requestParameters['staffId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/orderFile/uploadOutboundImg`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 上传出库实拍图片
     */
    async orderFileUploadOutboundImgPost(requestParameters: OrderFileUploadOutboundImgPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderFileUploadOutboundImgPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
